<script setup>

import {onMounted, ref} from "vue";
import {GetOrganisation} from "@/services/organisationService.js";
import {useRoute, useRouter} from "vue-router";
import OrganisationLayout from "@/layouts/OrganisationLayout.vue";
import {Label} from "@/components/ui/label/index.js";
import {Card, CardContent, CardFooter, CardHeader, CardTitle} from "@/components/ui/card/index.js";
import {ChevronRight, Loader} from "lucide-vue-next";
import {Input} from "@/components/ui/input/index.js";
import {Button} from "@/components/ui/button/index.js";
import {getContext} from "@/services/context.js";
import {CreateApp} from "@/services/appService.js";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {Platforms} from "@/enums.js";

const route = useRoute();
const router = useRouter();

let isLoading = ref(true);
let organisationModel = ref(null);

const name = ref('')
const platform = ref('')

onMounted(async () => {
  organisationModel.value = await GetOrganisation(getContext(route));
  isLoading.value = false;
});

async function onSubmit(event) {
  event.preventDefault();
  isLoading.value = true;
  
  let response = await CreateApp(getContext(route), name.value, platform.value);
}
</script>

<template>
  <OrganisationLayout :organisation="organisationModel">
    <div class="flex-1 space-y-4 pt-8">
      <div class="container mx-auto">
        <Card class="w-full mx-auto">
          <CardHeader>
            <CardTitle class="text-2xl">
              Create app
            </CardTitle>

          </CardHeader>
          <CardContent class="grid gap-4">
            <div class="grid gap-2">
              <div>
                <Label for="name">App name</Label>
                <Input
                    id="name"
                    type="text"
                    placeholder="My awesome app"
                    required
                    :disabled="isLoading"
                    v-model="name"
                />
              </div>
              <div>
                <Label for="name">Platform</Label>
                <Select v-model="platform">
                  <SelectTrigger class="w-full">
                    <SelectValue placeholder="Choose a platform"/>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem
                        v-for="status in Platforms.toSelect()"
                        :key="status.value"
                        :value="status.value"
                    >
                      {{ status.label }}
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button class="w-1/3 mr-8" @click="router.back()" variant="ghost" :disabled="isLoading">
              Cancel
            </Button>

            <Button class="w-2/3" @click="onSubmit" :disabled="isLoading">
              <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin"/>
              Next
              <ChevronRight/>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  </OrganisationLayout>
</template>

<style scoped>

</style>